import { Head } from '@inertiajs/react'
import { ApiReferenceReact } from '@scalar/api-reference-react'
import { Navbar } from '@/components/landing/Navbar'
import { Footer } from '@/components/landing/Footer'
import '@scalar/api-reference-react/style.css'

export default function Explorer() {
  return (
    <div className="min-h-screen flex flex-col">
      <Head title="API Explorer — KonexZero" />
      <Navbar />
      <main className="flex-1 pt-24">
        <ApiReferenceReact
          configuration={{
            url: '/api/v1/docs/openapi',
            theme: 'kepler',
            hideDownloadButton: false,
            hideModels: false,
            defaultHttpClient: {
              targetKey: 'js',
              clientKey: 'fetch',
            },
          }}
        />
      </main>
      <Footer />
    </div>
  )
}
